/**
 * 登录部分的api请求
 */
import fetch from "../fetch"
import loginUrl from '../urls/login'

export default {
	userAuthentication(data) {
		// 登录验证 0管理员 1学生 2教师 3教务 4专家 5开发 6专业组 7普通用户
		return fetch({
			url: `/apiuser/ZdapSSO/LoginByPassword`,
			method: "post",
			data
		});
	},
	GetExperienceToken(data) { //首页体验Token
	    return fetch({
	        url: loginUrl.GetExperienceToken,
	        method: 'get',
	        data,
	    })
	},
    SaveIntentionUser(data) { 
	    return fetch({
	        url: loginUrl.SaveIntentionUser,
	        method: 'post',
	        data,
	    })
	},
    GetToken(data) { 
	    return fetch({
	        url: loginUrl.GetToken,
	        method: 'get',
	        data,
	    })
	},
}



// WEBPACK FOOTER //
// ./src/api/apis/login.js